import { Headset, Lock, SealCheck } from '@liveauctioneers/hammer-ui-core/icons';
import { useIntl } from '@liveauctioneers/hammer-ui-core/intl';
import { BodyPrimary } from '@liveauctioneers/hammer-ui-core/text';

const BENEFITS = [
    { icon: SealCheck, intlKey: 'catalogPagePurchaseProtection.vetted' },
    { icon: Lock, intlKey: 'catalogPagePurchaseProtection.secure' },
    { icon: Headset, intlKey: 'catalogPagePurchaseProtection.support' },
] as const;

export const BenefitsIconList = () => {
    const { formatMessage } = useIntl();
    return (
        <div className="absolute -right-[75px] top-1/2 hidden h-[220px] w-[430px] -translate-y-1/2 rounded-[200px] bg-background-inverse desktop:flex tabletMin:w-[500px]">
            <div className="absolute right-0 top-1/2 z-10 flex -translate-y-1/2 flex-col gap-sm py-sm pr-[130px] lgMin:pr-[150px] mdMin:pr-[135px]">
                {BENEFITS.map(({ icon: Icon, intlKey }) => (
                    <div
                        className="flex items-center gap-xs text-text-inverse"
                        key={intlKey}
                    >
                        <Icon size="sm" />
                        <BodyPrimary className="hui-text-h5 text-text-inverse">
                            {formatMessage({ id: intlKey })}
                        </BodyPrimary>
                    </div>
                ))}
            </div>
        </div>
    );
};
